import axios, { AxiosError } from "axios";

import {
    CompleteCreateVideoConsultationSuccessResult,
    MarkVideoConsultationAsUnableBookSuccessResult,
    UnableToBookVideoConsultationRequestModel,
    UpdateVideoMeetingTaskSuccessResult
} from "./model";

const createVideoMeeting = async (ohCaseId: string, taskId: string) => {
    try {
        const response = await axios.post<UpdateVideoMeetingTaskSuccessResult>(`/api/videoMeetings/create/${ohCaseId}/${taskId}`);
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 400) {
            const error = { message: axiosError?.response?.data, status: 400 };
            throw error;
        }

        throw ex;
    }
};

const markVideoConsultationAsUnableBook = async (ohCaseId: string, taskId: string, justification: string) => {
    try {
        const requestModel: UnableToBookVideoConsultationRequestModel = {
            justification
        };
        const response = await axios.post<MarkVideoConsultationAsUnableBookSuccessResult>(
            `/api/videoMeetings/${ohCaseId}/unableToBook/${taskId}`, requestModel);
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 400) {
            const error = { message: axiosError?.response?.data, status: 400 };
            throw error;
        }

        throw ex;
    }
};

const completeCreateVideoConsultation = async (ohCaseId: string, taskId: string) => {
    try {
        const response = await axios.post<CompleteCreateVideoConsultationSuccessResult>(
            `/api/videoMeetings/${ohCaseId}/completeCreateVideoConsultation/${taskId}`);
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 400) {
            const error = { message: axiosError?.response?.data, status: 400 };
            throw error;
        }

        throw ex;
    }
};

export const videoMeetingsApi = {
    createVideoMeeting,
    markVideoConsultationAsUnableBook,
    completeCreateVideoConsultation
};
